import { render } from "./DriverDashboardProjectItem.vue?vue&type=template&id=1b04e29c"
import script from "./DriverDashboardProjectItem.vue?vue&type=script&lang=js"
export * from "./DriverDashboardProjectItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__